var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v("Letzte Nachricht")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","range-separator":"bis","start-placeholder":"Start","end-placeholder":"Ende","value-format":"yyyy-MM-dd","format":"dd.MM.yyyy"},on:{"input":function($event){_vm.$parent.$emit('filter-update', {
        value: $event ? $event.join('+') : null,
        name: _vm.name
      })}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }